import React from 'react';
import Heading from 'components/UI/Heading/Heading';
import MoneyFormat from 'components/UI/Money/MoneyFormat';

const LocationListDetail = ({ param, currency }) => {

    console.log("param currency === ", currency);

    const dateBegin = new Date(param?.dateDebut).toLocaleDateString('fr-FR');
    const dateEnd = new Date(param?.dateFin).toLocaleDateString('fr-FR');

    const montantTotal = currency === 'Ar' ? param?.montantAriary : param?.montantEuro;
    return (
        <form>
            <div>
                <Heading as="h2" content={`${param?.nomLogement} ( ${param?.nomPartenaire} ) `} />
                <Heading as="h3" content="Date de la réservation" />
                <div>{`Date d'arrivée : ${dateBegin}`}</div>
                <div>{`Date de départ : ${dateEnd}`}</div>
                <div>{`Nombre de personnes : ${param?.nombrePersonnes}`}</div>
                <div>{`Nombre de chambres : ${param?.nombreChambres}`}</div>
                <div>{`Quartier : ${param?.quartier}`}</div>

                <div>{`Vous avez sélectionné : `}</div>
                <div>{`${param?.nbPersonneAdulte} x personne(s) `}</div>

                <Heading as="h3" content="Récapitulatif du montant" />
                <div>{`Total à payer :`}</div>
                <MoneyFormat value={montantTotal} suffix={` ${currency}`} />
            </div>
        </form>
    );
};

export default LocationListDetail;